import Joi from '@hapi/joi'

export const DailyTaskDetailReportschemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    divisionID: Joi.number().invalid(0).label("Collection Point").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),
    //searchDate: Joi.string().invalid("").label("Search Date"),
    searchDate: Joi.string().invalid("").required().label("Search Date").messages({
        "any.invalid": `Select Search Date`,
        "any.required": `Search Date required`
    }),

    

    
}

